module.exports = __webpack_public_path__ + "static/img/Bachelor_010830.343a944.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010830.jpg
// module id = 260
// module chunks = 0